// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Search, ShoppingCart, MapPin, Globe, Menu, X } from 'lucide-react';
// import { useLanguage } from '../contexts/LanguageContext';
// import { useCart } from '../contexts/CartContext';
// import { useLocation } from '../contexts/LocationContext';
// import { Button } from './ui/button';
// import { Input } from './ui/input';
// import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
// import CartSidebar from './CartSidebar';

// export const Header = ({ onSearch }) => {
//   const { t, language, toggleLanguage } = useLanguage();
//   const { getItemCount, setIsCartOpen } = useCart();
//   const { location, isDetecting } = useLocation();
//   const [searchQuery, setSearchQuery] = useState('');
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (onSearch) {
//       onSearch(searchQuery);
//     }
//   };

//   const itemCount = getItemCount();

//   return (
//     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm" data-testid="header">
//       <div className="max-w-7xl mx-auto">
//         {/* Top bar */}
//         <div className="flex items-center justify-between px-4 md:px-8 py-3 border-b border-gray-50">
//           {/* Logo */}
//           <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
//             <div className="w-10 h-10 bg-[#0052CC] rounded-lg flex items-center justify-center">
//               <span className="text-white font-bold text-lg">M</span>
//             </div>
//             <span className="font-heading font-bold text-xl text-gray-900 hidden sm:block">GIZI.AI</span>
//           </Link>

//           {/* Search - Desktop */}
//           <form onSubmit={handleSearch} className="hidden md:flex flex-1 max-w-xl mx-8">
//             <div className="relative w-full">
//               <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <Input
//                 type="text"
//                 placeholder={t('search_placeholder')}
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full rounded-full border-gray-200 bg-gray-50 focus:bg-white focus:border-[#0052CC] focus:ring-2 focus:ring-[#0052CC]/20 pl-12 pr-4 py-2.5"
//                 data-testid="search-input"
//               />
//             </div>
//           </form>

//           {/* Right actions */}
//           <div className="flex items-center gap-2 md:gap-4">
//             {/* Location - Desktop */}
//             <div className="hidden lg:flex items-center gap-2 text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-full">
//               <MapPin className="w-4 h-4 text-[#0052CC]" />
//               <span className="max-w-[150px] truncate" data-testid="location-display">
//                 {isDetecting ? t('detecting_location') : location.name}
//               </span>
//             </div>

//             {/* Language Toggle */}
//             <Button
//               variant="ghost"
//               size="sm"
//               onClick={toggleLanguage}
//               className="flex items-center gap-1 text-gray-600 hover:text-[#0052CC]"
//               data-testid="language-toggle"
//             >
//               <Globe className="w-4 h-4" />
//               <span className="uppercase font-medium">{language}</span>
//             </Button>

//             {/* Cart */}
//             <Sheet>
//               <SheetTrigger asChild>
//                 <Button
//                   variant="ghost"
//                   size="sm"
//                   className="relative flex items-center gap-1 text-gray-600 hover:text-[#0052CC]"
//                   data-testid="cart-button"
//                 >
//                   <ShoppingCart className="w-5 h-5" />
//                   {itemCount > 0 && (
//                     <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#FF9900] text-white text-xs font-bold rounded-full flex items-center justify-center" data-testid="cart-count">
//                       {itemCount}
//                     </span>
//                   )}
//                   <span className="hidden sm:inline ml-1">{t('cart')}</span>
//                 </Button>
//               </SheetTrigger>
//               <SheetContent side="right" className="w-full sm:max-w-md p-0">
//                 <CartSidebar />
//               </SheetContent>
//             </Sheet>

//             {/* Mobile menu */}
//             <Button
//               variant="ghost"
//               size="sm"
//               className="md:hidden"
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//               data-testid="mobile-menu-toggle"
//             >
//               {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
//             </Button>
//           </div>
//         </div>

//         {/* Mobile Search */}
//         <div className="md:hidden px-4 py-3">
//           <form onSubmit={handleSearch}>
//             <div className="relative">
//               <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <Input
//                 type="text"
//                 placeholder={t('search_placeholder')}
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full rounded-full border-gray-200 bg-gray-50 focus:bg-white focus:border-[#0052CC] pl-12 pr-4 py-2.5"
//                 data-testid="mobile-search-input"
//               />
//             </div>
//           </form>
//         </div>

//         {/* Mobile Location */}
//         <div className="md:hidden px-4 pb-3 lg:hidden">
//           <div className="flex items-center gap-2 text-sm text-gray-600">
//             <MapPin className="w-4 h-4 text-[#0052CC]" />
//             <span className="truncate" data-testid="mobile-location-display">
//               {isDetecting ? t('detecting_location') : location.name}
//             </span>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ShoppingCart, MapPin, Globe, Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCart } from '../contexts/CartContext';
import { useLocation } from '../contexts/LocationContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import CartSidebar from './CartSidebar';

export const Header = ({ onSearch }) => {
  const { t, language, toggleLanguage } = useLanguage();
  const { getItemCount, setIsCartOpen } = useCart();
  const { location, isDetecting } = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchQuery);
    }
  };

  const itemCount = getItemCount();

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto">
        {/* Top bar */}
        <div className="flex items-center justify-between px-4 md:px-8 py-3 border-b border-gray-50">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <img
              src="https://kontentutorialmpstore-cdn.maduraprime.com/85e24262-ce3a-4e64-8c4d-82f74f0f3afe.png"
              alt="GIZI.AI Logo"
              className="w-10 h-10 object-contain"
            />
            <div className="hidden sm:flex flex-col">
              <span className="font-heading font-bold text-xl text-gray-900 leading-tight">
                GIZI.AI
              </span>
              <span className="text-[10px] text-gray-500 font-medium italic -mt-0.5">
                Kadin Indonesia
              </span>
            </div>
          </Link>

          {/* Search - Desktop */}
          <form onSubmit={handleSearch} className="hidden md:flex flex-1 max-w-xl mx-8">
            <div className="relative w-full">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="text"
                placeholder={t('search_placeholder')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-full border-gray-200 bg-gray-50 focus:bg-white focus:border-[#0052CC] focus:ring-2 focus:ring-[#0052CC]/20 pl-12 pr-4 py-2.5"
                data-testid="search-input"
              />
            </div>
          </form>

          {/* Right actions */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Location - Desktop */}
            <div className="hidden lg:flex items-center gap-2 text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-full">
              <MapPin className="w-4 h-4 text-[#0052CC]" />
              <span className="max-w-[150px] truncate" data-testid="location-display">
                {isDetecting ? t('detecting_location') : location.name}
              </span>
            </div>

            {/* Language Toggle */}
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="flex items-center gap-1 text-gray-600 hover:text-[#0052CC]"
              data-testid="language-toggle"
            >
              <Globe className="w-4 h-4" />
              <span className="uppercase font-medium">{language}</span>
            </Button>

            {/* Cart */}
            <Sheet>
              <SheetTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="relative flex items-center gap-1 text-gray-600 hover:text-[#0052CC]"
                  data-testid="cart-button"
                >
                  <ShoppingCart className="w-5 h-5" />
                  {itemCount > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#FF9900] text-white text-xs font-bold rounded-full flex items-center justify-center" data-testid="cart-count">
                      {itemCount}
                    </span>
                  )}
                  <span className="hidden sm:inline ml-1">{t('cart')}</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-full sm:max-w-md p-0">
                <CartSidebar />
              </SheetContent>
            </Sheet>

            {/* Mobile menu */}
            <Button
              variant="ghost"
              size="sm"
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Search */}
        <div className="md:hidden px-4 py-3">
          <form onSubmit={handleSearch}>
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="text"
                placeholder={t('search_placeholder')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-full border-gray-200 bg-gray-50 focus:bg-white focus:border-[#0052CC] pl-12 pr-4 py-2.5"
                data-testid="mobile-search-input"
              />
            </div>
          </form>
        </div>

        {/* Mobile Location */}
        <div className="md:hidden px-4 pb-3 lg:hidden">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MapPin className="w-4 h-4 text-[#0052CC]" />
            <span className="truncate" data-testid="mobile-location-display">
              {isDetecting ? t('detecting_location') : location.name}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;